// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";

export const ExcelReportDataContainer = styled.div`
    height: 100%;
    & > div:not(:last-child) {
        margin-bottom: 38px;
    }
`;